/**
 * Centralized Storage Service
 *
 * Handles browser storage for session data.
 * - API keys: sessionStorage (cleared when browser closes)
 */

// ============================================
// API Key Storage (sessionStorage)
// ============================================

const API_KEY_STORAGE_KEY = 'api_key'

/**
 * Store API key in sessionStorage
 * Used by TakaTV to persist the key across page refreshes during the session
 */
export function storeApiKey(key: string): void {
  sessionStorage.setItem(API_KEY_STORAGE_KEY, key)
}

/**
 * Get API key from sessionStorage
 */
export function getApiKey(): string | null {
  return sessionStorage.getItem(API_KEY_STORAGE_KEY)
}

/**
 * Clear API key from sessionStorage
 */
export function clearApiKey(): void {
  sessionStorage.removeItem(API_KEY_STORAGE_KEY)
}
